import React from "react";
import { ParamsWatcher } from "../helpers/params";

export default function LoaderDebug({ params }: { params: ParamsWatcher }): React.ReactElement {
  const stats = React.useSyncExternalStore(
    params.subscribeStats.bind(params),
    params.getStats.bind(params),
  );
  return (
    <pre
      style={{
        fontFamily: "monospace",
        textAlign: "left",
        fontSize: "12px",
      }}
    >
      <div>Reading from DB: {stats.readingFromDb}</div>
      <div>Reading from devices: {stats.readingFromDevice}</div>
    </pre>
  );
}

// export default function LoaderDebug({ params }: { params: ParamsWatcher }): React.ReactElement {
//   const stats = React.useSyncExternalStore(params.subscribeStats, params.getStats);
//   const dots: ReactElement[] = [];
//   for (let i = 0; i < stats.readingFromDb; i++) {
//     dots.push(<Dot key={i} color={OpenColor.green[8]} />);
//   }
//   for (let i = 0; i < stats.readingFromDevice; i++) {
//     dots.push(<Dot key={i} color={OpenColor.gray[6]} />);
//   }
//   return <div style={{ height: "2px" }}>{dots}</div>;
// }

// function Dot({ color }: { color: string }): React.ReactElement {
//   return (
//     <span
//       style={{
//         background: color,
//         width: "3px",
//         height: "5px",
//         display: "inline-block",
//         marginRight: "1px",
//       }}
//     ></span>
//   );
// }
